/** @jsx jsx */
import { jsx } from "@emotion/core";
import {
  Drawer as BaseDrawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";

import config from "../../configs";
import Icon from "../Icon";
import Button from "../Button";
import {
  drawer,
  drawerMini,
  logo as logoStyle,
  list,
  listMini,
  contact,
  button,
  buttonMini,
  buttonList,
  buttonUnselected,
  icon as iconStyle,
  iconMini,
  iconReversed,
  toggler,
  togglerMini,
} from "./styles";
import logo from "../../assets/images/logo.svg";
import smallLogo from "../../assets/images/small-logo.svg";

interface Item {
  icon: string;
  label: string;
  path?: string;
}

interface Props {
  items: Item[];
  open: boolean;
  onToggle: () => void;
}

const Drawer = ({ items, open, onToggle }: Props): JSX.Element => {
  const { pathname } = useLocation();

  const renderItems = (): JSX.Element[] =>
    items.map(({ icon, label, path = "#" }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ListItem key={`item-${index}`}>
        <Button
          css={[
            button,
            buttonList,
            !open && buttonMini,
            !pathname.startsWith(path) && buttonUnselected,
          ]}
          component={Link}
          to={path}
          eventProps={{ label }}
        >
          <ListItemIcon css={[iconStyle, !open && iconMini]}>
            <Icon name={icon} />
          </ListItemIcon>
          {open && <ListItemText primary={label} />}
        </Button>
      </ListItem>
    ));

  return (
    <BaseDrawer
      css={[drawer, !open && drawerMini]}
      variant="permanent"
      anchor="left"
    >
      <a style={{ margin: "auto" }} href={config.URL}>
        <img src={open ? logo : smallLogo} css={logoStyle} alt="DeepSeq.AI" />
      </a>
      <List css={[list, !open && listMini]}>
        {renderItems()}
        {open && (
          <ListItem
            css={contact}
            component="a"
            href={`mailto:${config.MAIL_ADDRESS}`}
          >
            {config.MAIL_ADDRESS}
          </ListItem>
        )}
        <ListItem css={[toggler, !open && togglerMini]}>
          <Button css={[button, buttonMini]} onClick={onToggle}>
            <ListItemIcon
              css={[iconStyle, !open && iconMini, !open && iconReversed]}
            >
              <Icon name="collapse" />
            </ListItemIcon>
            {open && <ListItemText primary="Click to Collapse Sidebar" />}
          </Button>
        </ListItem>
      </List>
    </BaseDrawer>
  );
};

export default Drawer;
